
























































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class PageSkeletonLoader extends Vue {
  @Prop() pageHeight: number;

  @Prop() timeout?: number;
  @Prop() timeoutMessage?: string;

  timeoutCompleted: boolean = false;

  mounted() {
    if (this.timeout) {
      setTimeout(() => (this.timeoutCompleted = true), this.timeout);
    }
  }
}
